import styled from 'styled-components'

export const ButtonSelectCourseStyle = styled.label`
  button {
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small
    }};
    border: ${({ theme }) => {
      return theme.border
    }};
    padding: 6px 24px;
    margin: 5px;
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.success
      }};
      color: ${({ theme }) => {
        return theme.colors.white
      }};
    }
  }
  .active {
    background-color: ${({ theme }) => {
      return theme.colors.success
    }};
    color: ${({ theme }) => {
      return theme.colors.white
    }};
  }

  @media screen and (max-width: 720px) {
    button {
      font-size: ${({ theme }) => {
        return theme.fonts.size.small
      }};
      margin: 0px;
    }
  }

  @media screen and (max-width: 480px) {
    button {
      font-size: ${({ theme }) => {
        return theme.fonts.size.superSmall
      }};
    }
  }
`
